// src/components/GlobalPresenceSection.jsx
import React from 'react';

const REGIONS = [
  { icon: 'fa-earth-americas', title: 'NORTH AMERICA', desc: 'International ingredient supply and customer partnerships.' },
  { icon: 'fa-earth-europe', title: 'EUROPE', desc: 'Serving quality-focused ingredient requirements.' },
  { icon: 'fa-earth-asia', title: 'ASIA', desc: 'Building strong and growing regional connections.' },
];

const CERTS = [
  { file: 'cert_usfda.jpg', alt: 'USFDA Registered' },
  { file: 'cert_halal.jpg', alt: 'Halal Certified' },
  { file: 'cert_spicesboard.jpg', alt: 'Spices Board India' },
  { file: 'cert_fssai.jpg', alt: 'FSSAI' },
  { file: 'cert_apeda.jpg', alt: 'APEDA' },
];

const GlobalPresenceSection = () => {
  return (
    <section
      className="page-content light"
      style={{
        backgroundImage: 'linear-gradient(rgba(11,31,20,0.75), rgba(11,31,20,0.9)), url(/assets/images/brand/world_map.jpg)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="container">
        <div className="section-header text-center">
          <h3>From India, Connected to the World</h3>
        </div>
        <p style={{ textAlign: 'center', maxWidth: 720, margin: '0 auto 30px' }}>
          Cornerstone is building a growing international supply network, serving customers across key
          markets in North America, Europe and Asia.
        </p>

        <div className="row" style={{ display: 'flex', flexWrap: 'wrap', marginBottom: 30 }}>
          {REGIONS.map((r, i) => (
            <div className="col-md-4 col-sm-12" key={i} style={{ textAlign: 'center', marginBottom: 20 }}>
              <i className={`fas ${r.icon}`} style={{ fontSize: 26, color: 'var(--brand-gold)', display: 'block', marginBottom: 10 }}></i>
              <div style={{ color: 'var(--brand-cream)', fontWeight: 700, marginBottom: 4 }}>{r.title}</div>
              <div style={{ color: 'var(--brand-cream-dim)', fontSize: 13 }}>{r.desc}</div>
            </div>
          ))}
        </div>

        <div
          style={{
            border: '1px solid var(--brand-gold)',
            borderRadius: 10,
            padding: '20px 10px',
          }}
        >
          <p style={{ textAlign: 'center', color: 'var(--brand-gold)', fontFamily: 'var(--brand-heading-font)', letterSpacing: 1, marginBottom: 18 }}>
            CERTIFIED &amp; COMPLIANCE-FOCUSED
          </p>
          <div
            style={{
              background: '#fff', borderRadius: 8, padding: '18px 10px',
              display: 'flex', flexWrap: 'wrap', alignItems: 'center', justifyContent: 'space-around', gap: 16,
            }}
          >
            {CERTS.map((c, i) => (
              <img key={i} alt={c.alt} title={c.alt} src={`/assets/images/brand/${c.file}`} style={{ height: 60, objectFit: 'contain' }} />
            ))}
          </div>
        </div>

        <p style={{ textAlign: 'center', marginTop: 24, color: 'var(--brand-gold-light)', fontFamily: 'var(--brand-heading-font)', fontSize: 18 }}>
          Quality that travels.
        </p>
        <p style={{ textAlign: 'center', maxWidth: 640, margin: '0 auto' }}>
          Our commitment to quality, compliance and responsible supply supports our growing presence
          across international markets.
        </p>
      </div>
    </section>
  );
};

export default GlobalPresenceSection;
